<template>
  <div
    class="sb-loading"
    data-sb-regression="sb-loading-spinner"
    :class="loadingClasses"
  >
    <div
      class="sb-loading-loader"
      :style="loadingStyles"
    >
      <!--
        @slot text, components, or HtmlElements as children of the component
      -->
      <slot>
        <sb-text value="common.loading" />...
      </slot>
    </div>
  </div>
</template>

<script>

/**
 * This is a loading overlay that can be used any time you need to indicate
 * to users that something is processing in the background.
 * Simply place this in the container element you want to indicate loading.
 * This can be used with the fade transition to toggle the loading component.
 * if you are not using fullscreen mode, make sure that the container element
 * has a css position attribute set as the loading component uses absolute positioning.
 */
export default {
  name: 'SbLoadingSpinner',
  props: {
    /**
     * Sets the size of the loading spinner.
     */
    size: {
      type: String,
      default: 'lg',
      validator: (value) => value.match(/(xtsm|sm|md|lg)/),
    },
    /**
     * Sets the loading component to fill the full screen size.
     */
    fullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({}),
  computed: {
    loadingStyles() {
      const fontSizeMap = {
        xtsm: '17px',
        sm: '30px',
        md: '60px',
        lg: '90px',
      };
      return {
        'font-size': fontSizeMap[this.size],
      };
    },
    loadingClasses() {
      const classes = ['loading'];
      if (this.fullScreen) classes.push('full-screen');
      return classes;
    },
  },
};
</script>

<style lang="scss">
@import '@src/components/Loading/style/sb-loading.scss';
</style>
